var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'mixin', 'app-common/view/dialog', 'app-common/component/notification', 'component/create-ledger'], function($, mixin, DialogView, NotificationSupport, CreateLedgerForm) {
  var CreateLedgerPage;
  return CreateLedgerPage = (function(_super) {

    __extends(CreateLedgerPage, _super);

    function CreateLedgerPage() {
      CreateLedgerPage.__super__.constructor.apply(this, arguments);
    }

    CreateLedgerPage.prototype.pageId = 'create-ledger';

    CreateLedgerPage.prototype.notificationSelector = function() {
      return '#dialog-window .notification-area';
    };

    CreateLedgerPage.prototype.events = {
      'click #create-ledger': 'addLedger'
    };

    CreateLedgerPage.prototype.footerHTML = '<div class="dialog-controls"><button id="create-ledger" class="btn btn-save">Add</button></div>';

    CreateLedgerPage.prototype.initialize = function(options, params) {
      this.render('');
      this.form = new CreateLedgerForm();
      this.form.render('<%= form %>' + this.footerHTML);
      return this.$el.append(this.form.$el);
    };

    CreateLedgerPage.prototype.addLedger = function() {
      var _this = this;
      return this.form.addLedger(function() {
        return _this.showNotification({
          type: 'success',
          text: 'Ledger account was created.'
        });
      });
    };

    return CreateLedgerPage;

  })(mixin.of(DialogView, NotificationSupport));
});
